import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import StreamSendMessageButton from 'components/stream-messaging/send-message-button'
import { SettingsSection } from 'pages/pga-coach/settings/settings-components'
import useSettingsStyles from 'pages/pga-coach/settings/settings.styles'
import { useStyles } from './styles'
import { formatDate } from './utils'

export const REACTION_EMOJI = {
  LOVED_IT: '😍',
  HELPFUL: '👍',
  SOMEWHAT_HELPFUL: '😐',
  NOT_HELPFUL: '👎',
}

const StudentFeedback = ({ request }) => {
  const classes = useStyles()
  const settingsClasses = useSettingsStyles()
  const { studentFeedback, student } = request

  if (!studentFeedback) return null

  const { reaction, comment, createdAt } = studentFeedback
  const emoji = REACTION_EMOJI[reaction] || reaction

  return (
    <SettingsSection eyebrow="Student feedback" classes={settingsClasses}>
      <Box className={classes.sectionBody}>
        <Box display="flex" alignItems="flex-start" style={{ gap: 16 }}>
          <Typography
            component="span"
            style={{ fontSize: '2rem', lineHeight: 1 }}
          >
            {emoji}
          </Typography>
          <Box>
            {comment ? (
              <Typography className={classes.notes}>{comment}</Typography>
            ) : (
              <Typography className={classes.helper}>
                No written comment.
              </Typography>
            )}
            {createdAt ? (
              <Typography className={classes.helper} style={{ marginTop: 8 }}>
                {formatDate(createdAt)}
              </Typography>
            ) : null}
          </Box>
        </Box>
        {student?.externalId ? (
          <Box className={classes.actionRow}>
            <StreamSendMessageButton
              userIds={[student.externalId]}
              variant="outlined"
              color="primary"
              classes={{ label: classes.buttonLabel }}
            >
              Continue in messages
            </StreamSendMessageButton>
          </Box>
        ) : null}
      </Box>
    </SettingsSection>
  )
}

StudentFeedback.propTypes = {
  request: PropTypes.shape({
    student: PropTypes.shape({ externalId: PropTypes.string }),
    studentFeedback: PropTypes.shape({
      reaction: PropTypes.string,
      comment: PropTypes.string,
      createdAt: PropTypes.string,
    }),
  }).isRequired,
}

export default StudentFeedback
